import * as React from 'react';
import { Button, Card, Col, Container, Form, Row, Table, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PostDocumentDetails, getDocumentByStudentID } from "../../api/studentDetails"
import { useEffect, useState } from 'react';

function DocumentDetails({ documents = [], courseId }) {
    const [photo, setPhoto] = useState(null);
    const [selectedDoc, setSelectedDoc] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');
    const [currentDocument, setCurrentDocument] = useState(null);
    const [studentDocument, setStudentDocument] = useState([]);
    const [errors, setErrors] = useState({});

    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const studentId = typeof window !== "undefined" ? localStorage.getItem("id") : null;


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type !== "application/pdf") {
            toast.error("Only PDF files are allowed.");
            setPhoto(null);
            return;
        }
        setPhoto(file);
         setErrors(prev => ({ ...prev, photo: "" }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // if (!photo || !selectedDoc) {
        //     toast.error("Please select a file and document type.");
        //     return;
        // }

        const newErrors = {};
        if (!selectedDoc) newErrors.selectedDoc = "Document is Required";
        if (!photo) newErrors.photo = "Please upload an document.";



        // If any errors, show them and stop here
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        if (!courseId) {
            toast.error("Course ID is missing.");
            return;
        }

        const formData = new FormData();
        formData.append("documentFile", photo);
        formData.append("documentId", selectedDoc);
        formData.append("courseId", courseId); // Include courseId in the form data

        console.log("FormData:", formData)
        try {
            const response = await PostDocumentDetails(studentId, courseId, token, formData);
            if (response.status === 200) {
                toast.success("Document uploaded successfully.");
                fetchDocuments(); // Refresh documents after upload
            } else {
                toast.error("Error while uploading document.");
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Failed to upload document. Please try again.");
        }
    };

    const fetchDocuments = async () => {
        try {
            const response = await getDocumentByStudentID(token, studentId, courseId);
            if (response.status === 200) {
                setStudentDocument(response.data);
            } else {
                toast.error("Failed to fetch documents.");
            }
        } catch (error) {
            toast.error("An error occurred while fetching documents.");
        }
    };

    const handleCancel = () => {
        setPhoto(null);
        setSelectedDoc("");
        setErrors({});
    }

    const handleChange = (e) => {
        const docId = e.target.value;
        setSelectedDoc(docId);
        console.log("DocumentId", docId);
         setErrors(prev => ({ ...prev, selectedDoc: "" }));
    }


    const handleDownload = (documentData) => {
        try {
            // Ensure we have access to the DOM
            if (typeof document.createElement !== "function") {
                throw new Error("DOM is not available.");
            }

            if (!documentData || !documentData.documentFile) {
                toast.error("Document file is missing.");
                return;
            }

            const base64Data = documentData.documentFile;
            const sanitizedBase64 = base64Data.replace(/[\s\r\n]+/g, '');

            const byteCharacters = atob(sanitizedBase64);
            const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);

            const contentType = documentData.contentType || 'application/pdf';
            const blob = new Blob([byteArray], { type: contentType });

            const fileName = documentData.fileName || "downloaded_document.pdf";

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(link.href);

        } catch (error) {
            console.error("Download error:", error);
            toast.error("Failed to download document. Check console for details.");
        }
    };


    useEffect(() => {
        fetchDocuments();
    }, [studentId, token]);

    return (
        <>
            <Container fluid>
                <Row className='mt-4'>
                    <Col>
                        <Card>
                            <div style={{ textAlign: "center" }}>
                                <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                    className='mb-3  mt-2'>Document Details</Form.Label>
                            </div>
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col xs={12} s={12} md={6} lg={6}>
                                            <Row>
                                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                                    <Form.Label column sm="4">
                                                        Document<span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Col sm="7">
                                                        <Form.Select value={selectedDoc}
                                                            onChange={handleChange} >
                                                            <option value="">Select Document</option>
                                                            {documents.map((doc) => (
                                                                <option key={doc.id} value={doc.document.id}>
                                                                    {doc.document.certificateName}
                                                                    {doc.isMandatory ? '*' : ''}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        {errors.selectedDoc && (
                                                            <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                                {errors.selectedDoc}
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Form.Group>
                                            </Row>
                                            <Row>
                                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                                    <Form.Label column sm="4">
                                                        Upload Document<span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Col sm="7">
                                                        <Form.Control type="file" accept=".pdf" onChange={handleFileChange} />
                                                         {errors.photo && (
                                                            <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                                {errors.photo}
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Form.Group>
                                            </Row>

                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                                                    <Button variant="primary" type="button"
                                                        onClick={handleSubmit}
                                                    >
                                                        Upload
                                                    </Button>
                                                    <ToastContainer />
                                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                                        onClick={handleCancel}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col>

                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Document</th>
                                                        <th>Document Link</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {studentDocument.map((doc) => (
                                                        <tr key={doc.id}>
                                                            <td>{doc.certificate.certificateName}</td>
                                                            <td>
                                                                <Button
                                                                    variant="link"
                                                                    onClick={() => handleDownload(doc)}

                                                                >
                                                                    Download
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </>
    );
};

export default DocumentDetails;